import { useRef } from 'react';
import { Tabs, Tab, ToggleButton, ButtonGroup } from 'react-bootstrap';
import Select from 'react-select';
import '../../../globalStyles/css/bootstrap/bootstrap.min.css';
import PrimaryDatePicker from '../../../components/PrimaryDatePicker';
import PrimaryAsyncSelect from '../../../components/PrimaryAsyncSelect';
import PrimaryDataTable from '../../../components/PrimaryDataTable';
// import { getAllModule } from '../../../api/transactionListing';
import {
  AlertDefaultError,
  PermissionsGate,
} from '../../../components/PermissionsGate';
import { mdExpensesReportColumn } from '../const';
import { DefaultLayout } from '../../../components/Layouts';

const MDExpensesReportScreen = ({
  mdExpensesReportListData,
  formData,
  handleSearch,
  dateChange,
  handleChange,
  handleExport,
  handleDataTableChange,
  tableData,
  mdListDropdown,
}) => {
  return (
    <DefaultLayout title="MD Expenses">
      <Tabs
        id="controlled-tab-example"
        //activeKey={selectedTab}
        className="default-tab"
      >
        <Tab
          className="default-tab-content"
          eventKey="md_expenses_report"
          title="MD Expenses report"
        >
          <PermissionsGate
            scopes={['md_expenses_report']}
            //RenderError={AlertDefaultError}
          >
            <div className="row">
              <div className="col-sm-4">
                <label>MD Name </label>
                <Select
                  name="coa_id"
                  onChange={handleChange}
                  value={
                    formData.md_codes
                      ? mdListDropdown.find(
                          (row) => row.value === formData.md_codes,
                        )
                      : ''
                  }
                  options={mdListDropdown}
                />
              </div>
              <div className="col-sm-12">
                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="col-md-4">
                    <label>Date From</label>
                    <label className="req">*</label>
                    <PrimaryDatePicker
                      name={'from'}
                      datePickerFormat={'yyyy-MM-dd'}
                      datePickerFormatString={'YYYY-MM-DD'}
                      value={formData.from}
                      onChange={(date) =>
                        dateChange({
                          target: { name: 'from', value: date },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Date To</label>
                    <label className="req">*</label>
                    <PrimaryDatePicker
                      name={'to'}
                      datePickerFormat={'yyyy-MM-dd'}
                      datePickerFormatString={'YYYY-MM-DD'}
                      value={formData.to}
                      onChange={(date) =>
                        dateChange({
                          target: { name: 'to', value: date },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <label>&nbsp;</label>
                    <div>
                      <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <label>&nbsp;</label>
                    <div>
                      <button
                        className="btn btn-info float-right"
                        onClick={handleExport}
                      >
                        Export
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <PrimaryDataTable
              rows={tableData.data}
              columns={mdExpensesReportColumn}
              onChange={handleDataTableChange}
              getRowId={(row) => row.id}
              loading={tableData.loading}
            />
          </PermissionsGate>
        </Tab>
      </Tabs>
    </DefaultLayout>
  );
};

export default MDExpensesReportScreen;
